/*=========================================================================================
  File Name: state.js
  Description: Payment State
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

export default {
    orderConfirmation : {
      orderId : '',
      transactionId : '', 
      pickupNumber : '',
      pickupTime : '',
      restaurantId : '',
      createdDate : '',
      paymentType : '',
      orderDetails : [],
      restaurantName : '',
      phoneNumber : '',
      organizationNo : '',
      address : '',
      postNumber : '',
      city : ''
    },
    sessionToken : '',
    paymentLink : '',
    netsCheckoutOption : null,
    chargedAmount : 0,

    
}